import { t } from "../../services/formatters";
import { useClinkDirectPage } from "./useClinkDirectPage";
import { Button } from "../../components/Button";
import { Informative } from "../../components/Informative";
import { ErrorModal } from "../../components/ErrorModal";
import { useEffect } from "react";
import { EditAppointmentModal } from "../../components/EditAppointmentModal";
import { FormDatiUtenteClinkDirect } from "../../components/FormDatiUtenteClinkDirect";
import agenteImg from "../../assets/imgs/agente-clink-direct.svg";
import "@splidejs/splide/dist/css/splide.min.css";
import "./ClinkDirectPage.css";
import { useComponentMetric } from "../../lib/otel";

export const ClinkDirectPage = () => {
    const { next, read, fetchErrorMessage, fetchError, setFetchError, showModal, closeModal, isCreaAppuntamentoBusy, appointmentCompleted } = useClinkDirectPage();

const metric = useComponentMetric("clink-direct");
    useEffect(() => {
        if (true === appointmentCompleted) {
            window.dataLayer.push({
                event: "ga4_event",
                event_name: "fissa_appuntamento_clink",
                event_detail: `${read("agente_direct_clink")}`,
            });
        }
    }, [appointmentCompleted]);

    useEffect(() => {
        if (fetchError) {
            metric.trackError(fetchErrorMessage || "errore creazione appuntamento");
        }
    }, [fetchError]);


    return (
        <div id="clink-page-direct">
            {!appointmentCompleted ? (
                <>
                    <div className={`section page-title-component center-on-tablet text-center`}>
                        <h1 className="title-subito-apuntamento">
                            <span>
                                Ciao! <br /> Sai che non c’è bisogno di andare in filiale per avere una consulenza?
                            </span>{" "}
                            <br />
                        </h1>
                        <p className="fa-direct-header">
                            <h2 className="regular">Decidi tu dove e quando!</h2>
                        </p>

                        <br />
                        <img src={agenteImg} alt="" />
                    </div>

                    <FormDatiUtenteClinkDirect nomeAgente={read("nomeAgente")} />

                    <Informative />

                    <div className="section text-center">
                        <Button id="go-to-select-state-btn" onClick={next} classList="btn-responsive always-style" loading={isCreaAppuntamentoBusy()} text={t("conferma_appuntamento")} />
                    </div>

                    <ErrorModal
                        open={fetchError}
                        text={fetchErrorMessage}
                        onCloseModal={() => {
                            setFetchError(false);
                        }}></ErrorModal>

                    <EditAppointmentModal open={showModal} title={t("modifica_appuntamento")} text={t("modifica_appuntamento_esistente_unknown_nocf")} onCloseModal={closeModal} />
                </>
            ) : (
                <>
                    <div className="section padding-x2 thank-you-text-extended-component text-center">
                        <p className="text-lg bold">
                            Grazie {read("nome")}!
                            <br />
                            Abbiamo preso in carico la tua richiesta
                        </p>
                        <br />
                        <p>{read("nomeAgente")} ti contatterà a breve al numero che ci hai indicato.</p>
                    </div>
                </>
            )}
        </div>
    );
};
